export default __webpack_public_path__ + "static/media/emoji-money2.458c289d.svg";